import { Nav } from "@/components/Nav";
import { Seo } from "@/components/Seo";
import { ORG_SCHEMA, APP_SCHEMA, faqPageSchema } from "@/lib/schemas";
import { faqs } from "@/components/FAQ";
import { Hero } from "@/components/Hero";
import { Problem } from "@/components/Problem";
import { HowItWorks } from "@/components/HowItWorks";
import { Certification } from "@/components/Certification";
import { TrustGrid } from "@/components/TrustGrid";
import { Audience } from "@/components/Audience";
import { SampleReport } from "@/components/SampleReport";
import { FAQ } from "@/components/FAQ";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Seo
        title="Veristamp — Tamper-Evident Rental Condition Reports"
        description="Timestamped, hash-verified move-in and move-out reports for tenants and landlords. Designed to support California AB 2801 photo requirements. iOS & Android."
        path="/"
        jsonLd={[APP_SCHEMA, ORG_SCHEMA, faqPageSchema(faqs)]}
      />
      <Nav />
      <Hero />
      <Problem />
      <HowItWorks />
      <Certification />
      <TrustGrid />
      <Audience />
      <SampleReport />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
